export const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1400 },
    items: 1,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1400, min: 1000 },
    items: 1,
    slidesToSlide: 1,
  },
  medium: {
    breakpoint: { max: 1000, min: 500 },
    items: 1,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 500, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

export const textVariants = {
  hidden: {
    y: 0,
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.5, staggerChildren: 0.1 },
  },
};

export const promotionalTexts = [
  "Get 10% off on your first order",
  "Pre Order Handcrafted Gifts",
  "Selected Products from Indian Craftsmen",
];

export const defaultLocations = ["Bangalore", "Delhi", "Gurugram"];
